import { useQuery } from "@tanstack/react-query";
import { otpApi } from "./axios";
import {
  ServiceResponseI,
  OtpRequestPayloadI,
  OtpValidatePayloadI,
  OtpResendPayloadI,
  OtpRequestResponseI,
  OtpValidateResponseI,
  OtpResendResponseI,
} from "../../interfaces";
import { AxiosError } from "axios";

// Función para solicitar OTP (sin autenticación)
const otpRequest = async (
  payload: OtpRequestPayloadI
): Promise<ServiceResponseI<OtpRequestResponseI>> => {
  try {
    const { data } = await otpApi.post<ServiceResponseI<OtpRequestResponseI>>(
      "/request",
      payload
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    throw new Error((obj?.data as any)?.message || (err as Error).message);
  }
};

// Función para validar OTP (sin autenticación)
const otpValidate = async (
  payload: OtpValidatePayloadI
): Promise<ServiceResponseI<OtpValidateResponseI>> => {
  try {
    const { data } = await otpApi.post<ServiceResponseI<OtpValidateResponseI>>(
      "/validate",
      payload
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    throw new Error((obj?.data as any)?.message || (err as Error).message);
  }
};

// Función para reenviar OTP (sin autenticación)
const otpResend = async (
  payload: OtpResendPayloadI
): Promise<ServiceResponseI<OtpResendResponseI>> => {
  try {
    const { data } = await otpApi.post<ServiceResponseI<OtpResendResponseI>>(
      "/resend",
      payload
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    throw new Error((obj?.data as any)?.message || (err as Error).message);
  }
};

// Exportar las funciones individuales
export const otpRequestNoAuth = otpRequest;
export const otpValidateNoAuth = otpValidate;
export const otpResendNoAuth = otpResend;

// Hook personalizado para OTP
export const useOtp = () => {
  // No necesita useQuery ya que las operaciones OTP son acciones puntuales
  // En lugar de eso, exportamos las funciones para usar en los componentes
  
  return {
    otpRequest,
    otpValidate,
    otpResend,
  };
};